import * as React from 'react';

import BoxBody from 'components/BoxBody';
import Button from 'components/ButtonDeprecated';
import Buttons from 'components/Buttons';
import Dialog from 'components/Dialog';
import Divider from 'components/Divider';
import EventTracking from 'lib/EventTracking';
import Link from 'components/Link';
import LinkConstants, { ConstructedLinks } from 'constants/LinkConstants';
import Row from 'components/Row';
import Text from 'components/Text';
import TextWithIcon from 'components/TextWithIcon';

import type { IconName } from 'components/IconDeprecated';

export type Props = {
  peopleListUrl?: string | void;
  onRequestHide: () => void;
  uiContext: string; // where the user triggered this modal from
};

export const eventKeyPrefix = 'free_product_limits.learn_more_modal';

export default class FreeClassLimitsLearnMoreDialog extends React.PureComponent<Props> {
  componentDidMount() {
    this.trackEvent('view');
  }

  trackEvent = (event: string) => {
    EventTracking.trackKey(`${eventKeyPrefix}.${event}`, {
      ui_context: this.props.uiContext,
    });
  };

  renderItem = (title: React.ReactNode, subtext: React.ReactNode, icon: IconName) => {
    return (
      <TextWithIcon
        center={false}
        gutter="medium"
        iconSize="large"
        icon={icon}
        iconColor="chalkboard"
      >
        <Text weight="semibold" element="div">
          {title}
        </Text>
        <Text color="graphite" element="div">
          {subtext}
        </Text>
      </TextWithIcon>
    );
  };

  render() {
    const { onRequestHide, peopleListUrl } = this.props;
    const peopleListText = peopleListUrl ? (
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | void | undefined' is not assignable... Remove this comment to see the full error message
      <Link to={this.props.peopleListUrl} onClick={onRequestHide}>
        People List
      </Link>
    ) : (
      'People List'
    );

    return (
      <Dialog
        size="xxsmall"
        onRequestHide={onRequestHide}
        title="With a free Remind account, announcements are available for:"
      >
        <BoxBody>
          <Text lineHeight="xlarge">
            <Row size="small">
              {/* TODO: fetch class limit from backend instead of hardcoding */}
              {this.renderItem(
                'Your first 10 classes',
                <React.Fragment>
                  You can always archive additional classes from your{' '}
                  <Link to="/settings/organize_classes" onClick={onRequestHide}>
                    Account Settings
                  </Link>
                  .
                </React.Fragment>,
                'book'
              )}
            </Row>
            {/* TODO: fetch membership limit from backend instead of hardcoding */}
            {this.renderItem(
              'Classes with up to 150 people',
              <React.Fragment>
                You can always remove people from your class from your {peopleListText}.
              </React.Fragment>,
              'users'
            )}
            <Divider size="medium" />
            <Row>
              <Text color="graphite">
                To enable announcements for all of your classes, your organization can also purchase
                Remind Hub.
              </Text>
            </Row>
          </Text>
          <Buttons axis="y">
            <Button
              data-test="upgrade-org-button"
              href={ConstructedLinks.PLANS_GRID_FROM_FREE_PRODUCT_LIMITS}
              target="_blank"
              onClick={() => this.trackEvent('upgrade_organization.click')}
            >
              Upgrade your organization
            </Button>
            <Button
              data-test="learn-more-button"
              full
              size="xxxsmall"
              level="text"
              color="mascot"
              href={LinkConstants.FREE_PRODUCT_LIMITS}
              onClick={() => this.trackEvent('learn_more.click')}
              target="_blank"
            >
              <Text weight="semibold">Learn more</Text>
            </Button>
          </Buttons>
        </BoxBody>
      </Dialog>
    );
  }
}
